import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import LabelApi from '@/api/labels-api';
import { deepTrim } from '@/helpers/data';
import { commonModule, filterModule } from '@/store/modules/store-accessor';

@Module({ namespaced: true, name: "labels" })
export default class LabelModule extends VuexModule {
    public expenseLabels: LabelDto[] = [];

    public isLoadingExpenseLabelsTable = true;

    @Action
    async checkLabelExistence(data: CheckLabelExistenceDto) {
        const labelApi = new LabelApi();
        const response = await labelApi.checkLabelExistence(data);
        return response;
    }

    @Action({ commit: 'setExpenseLabels' })
    async getExpenseLabels(): Promise<LabelDto[]> {
        this.setIsLoadingExpenseLabelsTable(true);
        const labelApi = new LabelApi();
        const expenseLabels = await labelApi.getAllExpenseLabels();
        this.setIsLoadingExpenseLabelsTable(false);

        return expenseLabels;
    }

    @Action
    async addExpenseLabel(data: CreateLabelDto) {
        const labelApi = new LabelApi();

        data = deepTrim(data);
        const response = await labelApi.createExpenseLabel(data);
        await this.getExpenseLabels();
        await commonModule.getExpenseLabelsCombo();
        await filterModule.getPaymentsAndExpensesFilters();
        return response;
    }

    @Action
    async updateExpenseLabel(label: UpdateLabelDto) {
        label = deepTrim(label);
        const labelApi = new LabelApi();

        await labelApi.updateExpenseLabel(label.id, label);
        await this.getExpenseLabels();
        await commonModule.getExpenseLabelsCombo();
        await filterModule.getPaymentsAndExpensesFilters();
    }

    @Action
    async deleteExpenseLabel(label: DeleteLabelDto) {
        const labelApi = new LabelApi();

        await labelApi.deleteExpenseLabel(label.id);
        await this.getExpenseLabels();
        await commonModule.getExpenseLabelsCombo();
        await filterModule.getPaymentsAndExpensesFilters();
    }

    @Mutation
    public setExpenseLabels(expenseLabels: LabelDto[]): void {
        this.expenseLabels = expenseLabels;
    }


    @Mutation
    public setIsLoadingExpenseLabelsTable(isLoadingExpenseLabelsTable: boolean): void {
        this.isLoadingExpenseLabelsTable = isLoadingExpenseLabelsTable;
    }

}
